import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "closeable", "FooterComponent", "imageAlt", "ImageComponent", "imageSrc", "onClose", "onCloseComplete"];
import { DialogFooter } from '../DialogFooter';
import { Image } from '../Image';
import { DialogCloseButton } from '../DialogCloseButton';
import { DialogContextProvider } from '../Dialog/DialogContext';
import { Modal } from '../Modal';
import devLogger from 'react-utils/devLogger';
import emptyFunction from 'react-utils/emptyFunction';
import { filterProps } from '../../../utils/filterProps';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledModalBody = styled.div.withConfig({
  displayName: "Lightbox__StyledModalBody",
  componentId: "sc-1to6x6g-0"
})(({
  theme
}) => {
  return {
    display: 'block',
    height: '100%',
    // needed to account for overly tall images
    padding: theme.space['1400'],
    wordWrap: 'break-word'
  };
});
const FooterWrapper = styled.div.withConfig({
  displayName: "Lightbox__FooterWrapper",
  componentId: "sc-1to6x6g-1"
})(["bottom:0;color:inherit;position:absolute;width:100%;"]);
const DefaultFooterComponent = ({
  children
}) => {
  return /*#__PURE__*/_jsx(DialogContextProvider, {
    value: {
      use: 'lightbox',
      headerCallback: emptyFunction
    },
    children: /*#__PURE__*/_jsx(DialogFooter, {
      align: "between",
      children: children
    })
  });
};
export const Lightbox = _ref => {
  let {
      children,
      closeable = true,
      FooterComponent = DefaultFooterComponent,
      imageAlt,
      ImageComponent = Image,
      imageSrc = '',
      onClose,
      onCloseComplete
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (process.env.NODE_ENV !== 'production') {
    if (imageSrc && !imageAlt) {
      devLogger.warn({
        message: 'Lightbox: for better accessibility, please include a description ' + 'of the image in the `imageAlt` prop .',
        key: 'Lightbox: missing imageAlt prop'
      });
    }
  }
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsxs(Modal, Object.assign({}, domProps, tokenProps, {
    use: "lightbox",
    onCloseComplete: onCloseComplete,
    children: [closeable && /*#__PURE__*/_jsx(DialogCloseButton, {
      size: "lg",
      detached: true,
      onClick: onClose
    }), /*#__PURE__*/_jsx(StyledModalBody, {
      children: /*#__PURE__*/_jsx(ImageComponent, {
        alt: imageAlt,
        objectFit: "contain",
        src: imageSrc,
        blockSize: "100%",
        margin: "auto"
      })
    }), /*#__PURE__*/_jsx(FooterWrapper, {
      children: children && /*#__PURE__*/_jsx(FooterComponent, {
        children: children
      })
    })]
  }));
};
export default Lightbox;